module.exports = __webpack_public_path__ + "img/horizontal_7_6_pp13_0.9b5b6664.png";